import { useState } from 'react';
import { observer } from 'mobx-react';

import styles from './SearchBar.module.scss';

import { SearchInput } from '@components/SearchInput';
import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { SearchInputTheme } from '@components/SearchInput/SearchInput';
import { translate } from '@chaika/i18n/helper';

interface Props {
    searchParams: SearchParams;
    value?: string;
    onChange?(value: string): void;
}

export interface SearchParams {
    dataTest?: string;
    dataTestInput?: string;
    placeHolder?: string;
    /** Начальное значение строки поиска; внутри `VirtualTable` значение из URL приходит при гидрации. */
    defaultValue?: string;
    /** Внутри `VirtualTable` вызов дополнительно пишет значение в URL — ключ `<urlKey>.query` зарезервирован таблицей. */
    onSearchClick(value?: string): Promise<void> | void;
}

export const SearchBar = observer(
    ({
        searchParams: { onSearchClick, dataTest, dataTestInput, placeHolder, defaultValue },
        value: controlledValue,
        onChange,
    }: Props) => {
        const [innerValue, setInnerValue] = useState<string>(defaultValue ?? '');

        const value = controlledValue ?? innerValue;
        const setValue = onChange ?? setInnerValue;

        return (
            <div className={styles.root}>
                <SearchInput
                    withSmallLeftPadding
                    placeholder={placeHolder ?? translate('search')}
                    value={value}
                    theme={SearchInputTheme.White}
                    onChange={event => setValue(event.target.value)}
                    onCancelClick={() => {
                        setValue('');
                        onSearchClick();
                    }}
                    dataTest={dataTestInput}
                    onKeyDown={event => {
                        if (event.key === 'Enter') {
                            onSearchClick(value);
                        }
                    }}
                />
                <Button
                    modifiers={[ButtonModifiers.Big]}
                    theme={ButtonTheme.White}
                    dataTest={dataTest}
                    onClick={() => onSearchClick(value)}
                    label={translate('makeSearch')}
                />
            </div>
        );
    },
);
